'use client';

import type React from 'react';

interface ButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  buttonStyle?: 'red' | 'blue' | 'green' | 'gray';
  className?: string;
  title: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  buttonStyle = 'red',
  className = '',
  title,
  type = 'button',
  disabled = false,
}) => {
  const baseStyles =
    'px-4 py-2 rounded-lg font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

  const styleVariants = {
    red: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
    blue: 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500',
    green: 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500',
    gray: 'bg-gray-600 hover:bg-gray-700 text-white focus:ring-gray-500',
  };

  const disabledStyles = 'opacity-50 cursor-not-allowed';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${styleVariants[buttonStyle]} ${disabled ? disabledStyles : ''} ${className}`}
    >
      {title}
    </button>
  );
};

export default Button;
